// extracted by mini-css-extract-plugin
module.exports = {"shopping-list":"styles_shopping-list__pzlw_","shopping-list-title":"styles_shopping-list-title__Cvad9"};